import { registerBlockType } from "@wordpress/blocks";

import metadata from "./../../../blocks/mp3-player/block.json";
import Edit from "./Edit";
import "./editor.scss";
import { mp3playerIcon } from "./utils/icons";

if (window.h5apPlayer?.isPipe) {
  registerBlockType(metadata, {
    icon: mp3playerIcon,

    // Build in Functions
    edit: Edit,

    save: () => null,
  });
}
